import React, {useEffect} from 'react';
import track from 'utils/track';
import SalesIndex from './join';

export default function () {
  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'SC-PPP',
        sku: 'SC-PPP',
        name: 'Plant-Powered Playbook',
        variant: 'ppp-special',
        value: 97,
        currency: 'usd'
      }),
    []
  );
  return <SalesIndex ctaNoTimer ctaOverride="joinSales" />;
}
